import { graphql } from 'src/graphql';

export const Projects = graphql(`
  query Projects($filter: ProjectsFilter) {
    projects(first: 1000, filter: $filter) {
      nodes {
        _id
        name
        status
        users {
          _id
          status
          User {
            _id
            meta {
              identity {
                firstname
                lastname
              }
            }
          }
        }
        _user_id
        owner {
          displayName
        }
        askable_plus {
          due_date
        }
        created
      }
    }
  }
`);
